module.exports = __webpack_public_path__ + "img/zxs.00c11681.png";